import type { ComponentPropsWithoutRef } from 'react';

import { makeAbstractStatusDropdown } from '@components/abstract-status';

import { AppVersionStatus } from '../../applications.models';

export type ApplicationVersionStatusDropdownProps = ComponentPropsWithoutRef<
  typeof ApplicationVersionStatusDropdown
>;

/**
 * Renders a dropdown showing the current version state with the ability to
 * change it.
 */
export const ApplicationVersionStatusDropdown =
  makeAbstractStatusDropdown<AppVersionStatus>([
    {
      value: AppVersionStatus.InProgress,
      icon: 'hourglass half',
      variant: 'primary',
    },
    { value: AppVersionStatus.Released, icon: 'rocket', variant: 'secondary' },
    {
      value: AppVersionStatus.Eol,
      icon: 'minus',
      variant: 'muted',
      label: 'EOL',
    },
  ]);

export default ApplicationVersionStatusDropdown;
